export default function Privacy() {
  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "auto" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>

      <h2>1. Data We Collect</h2>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Usage data</li>
      </ul>

      <h2>2. How We Use Data</h2>
      <ul>
        <li>User authentication</li>
        <li>Personalized AI insights</li>
        <li>Improving platform experience</li>
      </ul>

      <h2>3. AI Processing</h2>
      <p>
        Your inputs may be processed by AI systems to generate recommendations.
      </p>

      <h2>4. Third-Party Services</h2>
      <ul>
        <li>OpenAI (AI processing)</li>
        <li>Railway (backend hosting)</li>
        <li>Vercel (frontend hosting)</li>
      </ul>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable measures to protect your data, but no system is fully secure.
      </p>

      <h2>6. User Rights</h2>
      <p>
        You may request access, correction, or deletion of your data.
      </p>

      <h2>7. Consent</h2>
      <p>
        By using our platform, you consent to this Privacy Policy.
      </p>

      <h2>8. Contact</h2>
      <p>
        Email: support@mdih.in
      </p>
    </div>
  );
}